import { playerComparisonEventsForMetricAtom } from '@/atoms/queries/player/playerEventDataComparison';
import { PLAYER_PREVIEW_EVENT_KEYS, PreviewEvents } from '@/components/tables/PreviewEvents';

export const PlayerComparisonPreviewEvents = () => (
  <PreviewEvents eventsAtom={playerComparisonEventsForMetricAtom} eventKeys={PLAYER_PREVIEW_EVENT_KEYS} />
);
